// extracted by mini-css-extract-plugin
export default {"col":"SecondOrder_col__2Iqia","row":"SecondOrder_row__LSbjy","phase3":"SecondOrder_phase3__wGxZM"};